
import { translate } from "react-i18next";
import * as React from "react";
import { hasSeasonRank } from "helpers/rank";
import settings from "../../../settings";

type IProps = {
  rank: number;
  seasonId: number;
  seasonRank: number;

  t: (arg0: string, arg1: any | void) => string;
};

const TooltipRank = (props: IProps) => {
  const t = props.t;

  if (hasSeasonRank(props.seasonRank, props.seasonId)) {
    const seasonName = settings.seasonNames[props.seasonId];
    return <div>{t('%(rank)s ранг в сезоне %(seasonName)s:tooltip', { rank: props.seasonRank, seasonName: seasonName })}</div>;
  } else {
    return <div>{t('%(rank)s уровень аккаунта:tooltip', { rank: props.rank })}</div>;
  }
};

export default translate()(TooltipRank);